import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// Chips removibles con selector "+ Agregar" — opera con ids (numéricos o string), muestra el texto del catálogo
// El dropdown de opciones se renderiza en un portal hacia document.body, para que ningún
// contenedor con overflow (modal, card) pueda recortarlo, y se posiciona en base al botón
export const CRM_ChipMultiSelect = ({ label, help, valores, opciones, editing, onAdd, onRemove }) => {
  const [mostrarOpciones, setMostrarOpciones] = useState(false);
  const [posicion, setPosicion] = useState(null);
  const wrapRef = useRef(null);
  const dropdownRef = useRef(null);
  const disponibles = opciones.filter((opt) => !valores.includes(opt.id));

  const calcularPosicion = () => {
    if (!wrapRef.current) return;
    const rect = wrapRef.current.getBoundingClientRect();
    setPosicion({ top: rect.bottom + 4, left: rect.left, minWidth: rect.width });
  };

  const handleToggle = () => setMostrarOpciones((v) => !v);

  useEffect(() => {
    if (!mostrarOpciones) return;
    calcularPosicion();

    const handleReposicionar = () => calcularPosicion();
    const handleClickFuera = (e) => {
      const dentroDelBoton = wrapRef.current && wrapRef.current.contains(e.target);
      const dentroDelDropdown = dropdownRef.current && dropdownRef.current.contains(e.target);
      if (!dentroDelBoton && !dentroDelDropdown) setMostrarOpciones(false);
    };

    window.addEventListener("scroll", handleReposicionar, true);
    window.addEventListener("resize", handleReposicionar);
    document.addEventListener("mousedown", handleClickFuera);
    return () => {
      window.removeEventListener("scroll", handleReposicionar, true);
      window.removeEventListener("resize", handleReposicionar);
      document.removeEventListener("mousedown", handleClickFuera);
    };
  }, [mostrarOpciones]);

  const handleAdd = (id) => {
    onAdd(id);
    setMostrarOpciones(false);
  };

  return (
    <div className="crm-detalle-clasificacion-fila">
      <div className="clasificacion-fila-label">
        <span className="fila-label-texto">{label}</span>
        {help && <span className="fila-label-help">{help}</span>}
      </div>
      <div className="clasificacion-fila-chips">
        {!editing && valores.length === 0 && (
          <span className="clasificacion-fila-vacio">No tiene {label.toLowerCase()} seleccionado{label.toLowerCase().endsWith("s") ? "s" : ""}</span>
        )}
        {valores.map((id) => (
          <span key={id} className="chip chip-seleccionado">
            {opciones.find((opt) => opt.id === id)?.display || id}
            {editing && (
              <button type="button" className="chip-remove" onClick={() => onRemove(id)}>×</button>
            )}
          </span>
        ))}
        {editing && disponibles.length > 0 && (
          <div className="chip-add-wrap" ref={wrapRef}>
            <button type="button" className="chip-add-pill" onClick={handleToggle}>
              + Agregar
            </button>
            {mostrarOpciones && posicion && createPortal(
              <div
                ref={dropdownRef}
                className="chip-add-dropdown chip-add-dropdown-fixed"
                style={{ top: posicion.top, left: posicion.left, minWidth: posicion.minWidth }}
              >
                {disponibles.map((opt) => (
                  <button key={opt.id} type="button" onClick={() => handleAdd(opt.id)}>{opt.display}</button>
                ))}
              </div>,
              document.body
            )}
          </div>
        )}
      </div>
    </div>
  );
};
